import React, { useEffect, useState } from 'react'
import Contactform from '../Components/Contactform'
import Pagehelmet from './Pagehelmet';

function Contact() {
  const [showPopup, setShowPopup] = useState(false);

  // Show popup automatically when user lands on this page
  useEffect(() => {
    setTimeout(() => {
      setShowPopup(true);
    }, 500); // delay so it feels smooth
  }, []);

  return (
    <div>
      <Pagehelmet pageTitle="Contact Us" />

      {/* ================== Popup Modal ================== */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-box rounded shadow">
            <button
              className="btn-close position-absolute top-0 end-0 m-2"
              onClick={() => setShowPopup(false)}
            ></button>
            <h5 className="mb-3">📄 FutureOil 2026 Brochure</h5>
            <p className="mb-0">
              To receive the full <strong>FutureOil 2026 event brochure</strong>, please fill out the contact form below.
              Our team will send the brochure directly to your email.
            </p>
          </div>
        </div>
      )}
      {/* ================================================= */}

      {/*--Contact Section--*/}
      <section className="contact" style={{ marginTop: 80, marginBottom: 40 }}>
        <div className="container">
          <div className="contact-inner text-center text-md-start">
            <div className="row g-md-5 gy-5 align-items-center">
              
              {/* Contact Info (Left) */}
              <div className="col-lg-4 col-md-5">
                <div className="contact-event-info p-8 text-white h-100 rounded bg-pink">
                  <div className="event-venue pb-4">
                    <h5 className="text-white pb-2">EVENT VENUE:</h5>
                    <p className="m-0">100% Virtual Conference</p>
                  </div>
                  <div className="date-info pb-4">
                    <h5 className="text-white pb-2">DATES:</h5>
                    <p className="m-0">21-22 April, 2026</p>
                  </div>
                  <div className="general">
                    <h5 className="text-white pb-2">GENERAL INQUIRIES:</h5>
                    <p className="m-0">Support Team</p>
                    <p className="m-0">
                      Email: <a href="mailto:info@aroevents.com" className="text-white">info@aroevents.com</a>
                    </p>
                  </div>
                </div>
              </div>

              {/* Contact Form (Right) */}
              <div className="col-lg-8 col-md-7">
                <div className="contact-form">
                  <div className="form-title mb-4">
                    <h2 className="mb-1">Drop a <span className="pink">line</span></h2>
                    <p>
                      Have a question about FutureOil 2026? Reach out to our team and we’ll get back to you shortly.
                    </p>
                  </div>
                  <div className="form">
                    <Contactform />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================== Styles ================== */}
      <style>{`
        /* Popup overlay */
        .popup-overlay {
          position: fixed;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background: rgba(0,0,0,0.6);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
        }

        /* Popup box */
        .popup-box {
          background: #fff;
          padding: 25px 20px;
          max-width: 400px;
          width: 90%;
          text-align: center;
          position: relative;
        }

        .popup-box h5 {
          font-weight: 700;
          color: #d63384; /* pink highlight */
        }
      `}</style>
    </div>
  )
}

export default Contact
